export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    title: that.$l('INDEX.table_label_originalFileName') || '原始文件名',
    field: 'originalFileName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 200,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_platformName') || '电商平台名称',
    field: 'platformName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 200,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  // {
  //   title: '上传文件描述',
  //   field: 'uploadFileDesc',
  //   headerAlign: 'center',
  //   align: 'left',
  //   minWidth: 250,
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  // },
  {
    title: that.$l('INDEX.table_label_processFlag') || '文件处理标记',
    field: 'processFlag',
    width: 180,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'processFlag' }
  },
  {
    title: that.$l('INDEX.table_label_processMessage') || '处理结果',
    field: 'processMessage',
    headerAlign: 'center',
    align: 'left',
    minWidth: 250,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_processDatetime') || '文件处理时间',
    field: 'processDatetime',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_processResultJson') || '处理结果 JSON',
    field: 'processResultJson',
    headerAlign: 'center',
    align: 'left',
    minWidth: 250,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_uploadBy') || '上传人',
    field: 'createdByName',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_uploadDate') || '上传时间',
    field: 'creationTime',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'updatedByName',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    field: 'updatedTime',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
